import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button-icon',
  template: `
    <mat-icon class="mr-2 align-middle" *ngIf="!loading"><ng-content></ng-content></mat-icon>
    <mat-progress-spinner
                          *ngIf="loading"
                          class="d-inline-block mr-2 align-middle"
                          color="accent"
                          diameter="24"
                          mode="indeterminate">
    </mat-progress-spinner>
  `,
  host: {
    'class': 'd-inline-block align-middle lh-1'
  }
})
export class ButtonIconComponent {
  @Input() set loading(value: any) {
    this._loading = coerceBooleanProperty(value);
  };

  get loading(): boolean {
    return this._loading;
  }

  private _loading: boolean = false;
}
